// src/pages/PDFViewerPage.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import PDFViewer from '../components/players/PDFViewer';

const PDFViewerPage = () => {
  const location = useLocation();
  const { fileUrl, mediaId, title } = location.state || {};

  return (
    <PDFViewer
      mediaId={mediaId}
      fileUrl={fileUrl}
      title={title}
    />
  );
};

export default PDFViewerPage;